export const ACCESS_TOKEN_KEY = 'access_token';
export const DEFAULT_ACCESS_TOKEN_EXPIRES_IN = 86400; // 1 dia em segundos
export const ACCESS_TOKEN_KEY_CADASTRAL_CHANGE = 'changeCadastralToken';
export const ACCESS_TOKEN_EXPIRES_IN_CADASTRAL_CHANGE = 600; // 10 min em segundos
